// extracted by mini-css-extract-plugin
module.exports = {"title":"cartSection-module--title--3ftmA","row":"cartSection-module--row--3ra3m","col":"cartSection-module--col--2kfDn"};